"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var descriptionKeys = {};

var _default = function _default(description) {
  if (descriptionKeys[description]) return descriptionKeys[description];
  var hash = 0;
  if (description.length === 0) return hash;
  description.split('').forEach(function (char) {
    hash = (hash << 5) - hash + char.charCodeAt(0);
    hash = hash & hash;
  });
  var key = "desc_" + hash.toString().replace('-', 'n');
  descriptionKeys[description] = key;
  return key;
};

exports.default = _default;
module.exports = exports.default;